export type BanUserFields = {
  permanent: boolean;
  reason: string;
  date: Date;
  hour: string;
  timezone: string;
};

export type BanUserValidate = {
  reason?: string;
  date?: string;
  permanent?: boolean;
};

export const hoursSelect = new Array(24).fill(null).map((item, index) => {
  return {
    children: `${index > 9 ? index : `0${index}`}:00`,
    value: `${index > 9 ? index : `0${index}`}:00:00`
  };
});

export const timezoneSelect = [
  { children: 'GMT', value: '+0000' },
  { children: 'GMT +1', value: '+0100' },
  { children: 'GMT +2', value: '+0200' },
  { children: 'GMT +3', value: '+0300' },
  { children: 'GMT +4', value: '+0400' },
  { children: 'GMT +5', value: '+0500' },
  { children: 'GMT +6', value: '+0600' },
  { children: 'GMT +7', value: '+0700' },
  { children: 'GMT +8', value: '+0800' },
  { children: 'GMT +9', value: '+0900' },
  { children: 'GMT +10', value: '+1000' },
  { children: 'GMT +11', value: '+1100' },
  { children: 'GMT -1', value: '+1200' },
  { children: 'GMT -2', value: '+1300' },
  { children: 'GMT -3', value: '+1400' },
  { children: 'GMT -4', value: '+1500' },
  { children: 'GMT -5', value: '+1600' },
  { children: 'GMT -6', value: '+1700' },
  { children: 'GMT -7', value: '+1800' },
  { children: 'GMT -8', value: '+1900' },
  { children: 'GMT -9', value: '+2000' },
  { children: 'GMT -10', value: '+2100' },
  { children: 'GMT -11', value: '+2200' },
  { children: 'GMT -12', value: '+2300' }
];

export const maxTextLength = 200;

export const banUserFieldsValidator = (values: BanUserFields): BanUserValidate => {
  const errors: BanUserValidate = {};

  if (!values.reason) {
    errors.reason = 'app.validation.required';
  }
  if (values.reason?.length > maxTextLength) {
    errors.reason = 'app.validation.characters';
  }

  if (!values.date && !values.permanent) {
    errors.date = 'app.validation.required';
  }

  return errors;
};
